const readonlyField = (name, label, colProps = { md: 4 }) => ({
  name,
  label,
  component: 'FormField',
  type: 'text',
  disabled: true,
  colProps
});

const editableDateField = (name, label, colProps = { md: 4 }) => ({
  name,
  label,
  component: 'DateTimePicker',
  type: 'datetime-local',
  disabled: false,
  colProps
});

export const descargaFormularioStructure = [
  [
    readonlyField('numeroCarga', 'Numero da Carga'),
    readonlyField('protocoloCarga', 'Protocolo da Carga'),
    readonlyField('codigoCarga', 'Codigo da Carga')
  ],
  [
    readonlyField('situacaoCarga', 'Situacao da Carga', { md: 8 }),
    readonlyField('dataCriacaoCarga', 'Data Criacao Carga')
  ],
  [
    readonlyField('numeroPedido', 'Numero do Pedido'),
    readonlyField('protocoloPedido', 'Protocolo do Pedido'),
    readonlyField('codigoPedido', 'Codigo do Pedido')
  ],
  [
    readonlyField('dataAgendamentoPedido', 'Data Agendamento Pedido'),
    readonlyField('dataCriacaoPedido', 'Data Criacao Pedido'),
    readonlyField('dataCarregamentoPedido', 'Data Carregamento Pedido')
  ],
  [
    readonlyField('placaVeiculo', 'Placa do Veiculo'),
    readonlyField('numeroFrota', 'Numero da Frota'),
    readonlyField('descricaoModeloVeicular', 'Modelo Veicular')
  ],
  [
    readonlyField('placasReboque', 'Placas Reboque'),
    readonlyField('frotasReboque', 'Frotas Reboque'),
    readonlyField('modelosReboque', 'Modelos Reboque')
  ],
  [
    readonlyField('infoMotorista', 'Info Motorista', { md: 12 })
  ],
  [
    readonlyField('nomeRemetente', 'Remetente', { md: 6 }),
    readonlyField('cnpjRemetente', 'CNPJ Remetente', { md: 6 })
  ],
  [
    readonlyField('nomeDestinatario', 'Destinatario', { md: 6 }),
    readonlyField('cnpjDestinatario', 'CNPJ Destinatario', { md: 4 }),
    readonlyField('loja', 'Loja', { md: 2 })
  ],
  [
    readonlyField('nomeTomador', 'Tomador', { md: 6 }),
    readonlyField('cnpjTomador', 'CNPJ Tomador', { md: 6 })
  ],
  [
    readonlyField('nomeResponsavel', 'Responsavel'),
    editableDateField('dataAgendamento', 'Data Agendamento Descarga'),
    editableDateField('chegada', 'Chegada Descarga')
  ],
  [
    editableDateField('saida', 'Saida Descarga')
  ],
  [
    readonlyField('descricaoPosicaoAngellira', 'Posicao Angellira', { md: 6 }),
    readonlyField('codigoViagemAngellira', 'Codigo Viagem Angellira', { md: 6 })
  ],
  [
    readonlyField('statusViagemAngellira', 'Status Viagem Angellira', { md: 4 }),
    readonlyField('clienteDistanciaAngellira', 'Distancia Cliente', { md: 4 }),
    readonlyField('clienteTempoPrevChegadaAngellira', 'Tempo Prev Chegada', { md: 4 })
  ],
  [
    {
      name: 'observacoes',
      label: 'Observacoes Descarga',
      component: 'Textarea',
      type: 'textarea',
      rows: 4,
      disabled: false,
      colProps: { md: 12 }
    }
  ]
];

export const descargaFormularioSections = [
  {
    title: 'Dados da Carga',
    rows: [0, 1]
  },
  {
    title: 'Dados do Pedido',
    rows: [2, 3]
  },
  {
    title: 'Veiculo e Reboques',
    rows: [4, 5, 6]
  },
  {
    title: 'Remetente, Destinatario e Tomador',
    rows: [7, 8, 9]
  },
  {
    title: 'Dados da Descarga',
    rows: [10, 11]
  },
  {
    title: 'Angellira',
    rows: [12, 13]
  },
  {
    title: 'Observacoes',
    rows: [14]
  }
];
